module.exports = __webpack_public_path__ + "img/italic.d9982c10.svg";